export default __webpack_public_path__ + "static/media/valid.icon.a83c17bc.svg";